export const routes_names = {
  login: 'login',
  main: 'main',
  filters: 'filters',
  thresholds: 'thresholds',
  sip_servers: 'sip_servers',
  call_hangup_reports: 'call_hangup_reports',
  call_fail: 'call-fail',
  check_fail: 'check-fail',
  check_redis_fail: 'check-redis-fail',
}